var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.ServerOS
        ? _c(
            "el-row",
            { attrs: { gutter: 12 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "server-card", attrs: { shadow: "hover" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [_vm._v("CPU使用率(监测10秒)")]),
                          _c(
                            "el-button",
                            {
                              staticStyle: { float: "right", padding: "3px 0" },
                              attrs: { type: "text" },
                              on: { click: _vm.refreshList },
                            },
                            [_vm._v("刷新")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { span: 24 },
                            },
                            [
                              _c("el-progress", {
                                attrs: {
                                  type: "dashboard",
                                  percentage: _vm.ServerOS.cpu.used,
                                  color: _vm.colors,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "el-table el-table--enable-row-hover el-table--medium",
                              },
                              [
                                _c(
                                  "table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { cellspacing: "0" },
                                  },
                                  [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("CPU主频"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ServerOS.cpu.cpucard.processorIdentifier.name.split(
                                                  "@"
                                                )[1]
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("核心数"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ServerOS.cpu.cpucard
                                                  .logicalProcessorCount
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "server-card", attrs: { shadow: "hover" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [_vm._v("内存使用率(监测10秒)")]),
                          _c(
                            "el-button",
                            {
                              staticStyle: { float: "right", padding: "3px 0" },
                              attrs: { type: "text" },
                              on: { click: _vm.refreshList },
                            },
                            [_vm._v("刷新")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { span: 24 },
                            },
                            [
                              _c("el-progress", {
                                attrs: {
                                  type: "dashboard",
                                  percentage: _vm.ServerOS.mem.used,
                                  color: _vm.colors,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "el-table el-table--enable-row-hover el-table--medium",
                              },
                              [
                                _c(
                                  "table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { cellspacing: "0" },
                                  },
                                  [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("总内存"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v(
                                              _vm._s(_vm.ServerOS.mem.total) +
                                                "G"
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("已用内存"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v(
                                              _vm._s(_vm.ServerOS.mem.usedMem) +
                                                "G"
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "server-card", attrs: { shadow: "hover" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [_vm._v("JVM使用率(监测10秒)")]),
                          _c(
                            "el-button",
                            {
                              staticStyle: { float: "right", padding: "3px 0" },
                              attrs: { type: "text" },
                              on: { click: _vm.refreshList },
                            },
                            [_vm._v("刷新")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { span: 24 },
                            },
                            [
                              _c("el-progress", {
                                attrs: {
                                  type: "dashboard",
                                  percentage: _vm.ServerOS.jvm.used,
                                  color: _vm.colors,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "el-table el-table--enable-row-hover el-table--medium",
                              },
                              [
                                _c(
                                  "table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { cellspacing: "0" },
                                  },
                                  [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("JVM大小"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v(
                                              _vm._s(_vm.ServerOS.jvm.total) +
                                                "M"
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("已用JVM"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v(
                                              _vm._s(_vm.ServerOS.jvm.usedMem) +
                                                "M"
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "server-card", attrs: { shadow: "hover" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("span", [_vm._v("JAVA虚拟机信息")])]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "el-table el-table--enable-row-hover el-table--medium",
                        },
                        [
                          _vm.ServerOS
                            ? _c(
                                "table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { cellspacing: "0" },
                                },
                                [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v("JAVA名称"),
                                        ]),
                                      ]),
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ServerOS.sys["java.vm.name"]
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v("JAVA版本"),
                                        ]),
                                      ]),
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ServerOS.sys["java.version"]
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v("Java的安装路径 "),
                                        ]),
                                      ]),
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ServerOS.sys["java.home"]
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v("Java供应商"),
                                        ]),
                                      ]),
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ServerOS.sys["java.vendor"]
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v("Jvm最大可用内存"),
                                        ]),
                                      ]),
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v(
                                            _vm._s(_vm.ServerOS.jvm.maxTotal) +
                                              "M"
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "server-card", attrs: { shadow: "hover" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("span", [_vm._v("磁盘信息")])]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "el-table el-table--enable-row-hover el-table--medium",
                        },
                        [
                          _vm.ServerOS
                            ? _c(
                                "table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { cellspacing: "0" },
                                },
                                [
                                  _c(
                                    "tbody",
                                    [
                                      _c("tr", [
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("磁盘名称"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("大小"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("已用"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("可用"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _c("div", { staticClass: "cell" }, [
                                            _vm._v("利用率"),
                                          ]),
                                        ]),
                                      ]),
                                      _vm._l(
                                        _vm.ServerOS.file,
                                        function (disk, index) {
                                          return _c("tr", { key: index }, [
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "cell" },
                                                [_vm._v(_vm._s(disk.name))]
                                              ),
                                            ]),
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "cell" },
                                                [
                                                  _vm._v(
                                                    _vm._s(disk.total) + "G"
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "cell" },
                                                [
                                                  _vm._v(
                                                    _vm._s(disk.used) + "G"
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "cell" },
                                                [
                                                  _vm._v(
                                                    _vm._s(disk.free) + "G"
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "cell" },
                                                [
                                                  _c("el-progress", {
                                                    attrs: {
                                                      percentage: disk.rate,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]),
                                          ])
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "server-card", attrs: { shadow: "hover" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("span", [_vm._v("服务器信息")])]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "el-table el-table--enable-row-hover el-table--medium",
                        },
                        [
                          _vm.ServerOS
                            ? _c(
                                "table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { cellspacing: "0" },
                                },
                                [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v("服务器名称"),
                                        ]),
                                      ]),
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v(_vm._s(_vm.ServerOS.hostname)),
                                        ]),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v("操作系统"),
                                        ]),
                                      ]),
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ServerOS.sys["os.name"]
                                            ) +
                                              _vm._s(
                                                _vm.ServerOS.sys["os.version"]
                                              )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v("服务器IP"),
                                        ]),
                                      ]),
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v(_vm._s(_vm.ServerOS.ip)),
                                        ]),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v("系统架构"),
                                        ]),
                                      ]),
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v(
                                            _vm._s(_vm.ServerOS.sys["os.arch"])
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v("CPU"),
                                        ]),
                                      ]),
                                      _c("td", [
                                        _c("div", { staticClass: "cell" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ServerOS.cpu.cpucard.name
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }